import React, { useState } from "react";
import { Calendar as CalIcon } from "lucide-react";
import { format, parse, isValid } from "date-fns";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { Calendar } from "../ui/calendar";

// Calendar-popup date field styled to match SmartReach inputs. Value is an ISO date string (YYYY-MM-DD).
export default function DateField({ value, onChange, placeholder = "Pick a date", testId, minToday = false }) {
  const [open, setOpen] = useState(false);
  const selected = (() => {
    if (!value) return undefined;
    const d = parse(value, "yyyy-MM-dd", new Date());
    return isValid(d) ? d : undefined;
  })();

  const handle = (d) => {
    if (!d) { onChange(""); return; }
    onChange(format(d, "yyyy-MM-dd"));
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="sr-input" data-testid={testId}
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, cursor: "pointer", textAlign: "left", width: "100%" }}>
          <span style={{ color: selected ? "var(--navy, #0B2447)" : "#8a95a8" }}>
            {selected ? format(selected, "MMM d, yyyy") : placeholder}
          </span>
          <CalIcon size={16} color="#8a95a8" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={selected} onSelect={handle} initialFocus
          disabled={minToday ? { before: new Date() } : undefined}
          defaultMonth={selected || new Date()} />
      </PopoverContent>
    </Popover>
  );
}
